import { render, staticRenderFns } from "./ContentStaff.vue?vue&type=template&id=311a6f3d&scoped=true&"
import script from "./ContentStaff.vue?vue&type=script&lang=js&"
export * from "./ContentStaff.vue?vue&type=script&lang=js&"
import style0 from "./ContentStaff.vue?vue&type=style&index=0&id=311a6f3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a6f3d",
  null
  
)

export default component.exports